import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import LegacyUserOnboarding from '../../components/onboarding/LegacyUserOnboarding';
import EditableUserInfos from '@/types/editable-user-infos';
import User from '@/types/user';

type Props = {
  user: User;
  onSave: (info: EditableUserInfos) => Promise<User>;
} & RouteComponentProps;

const SettingsContact = ({ user, onSave }: Props) => (
  <div className="settings-contact settings-tab">
    <LegacyUserOnboarding user={user} onSave={onSave} />
  </div>
);

export default SettingsContact;
